// Styled pop-ups (SweetAlert2) used instead of the browser's alert()/confirm(),
// so every page looks the same. Each returns a promise.
import Swal from 'sweetalert2'

const BRAND = '#1d4ed8'

export function notifySuccess(text, title = 'Done') {
  return Swal.fire({ icon: 'success', title, text, confirmButtonColor: BRAND })
}

export function notifyError(text, title = 'Something went wrong') {
  return Swal.fire({ icon: 'error', title, text, confirmButtonColor: BRAND })
}

// For missing or invalid form input
export function notifyWarning(text, title = 'Please check the form') {
  return Swal.fire({ icon: 'warning', title, text, confirmButtonColor: BRAND })
}

// Resolves true when the person confirms. `danger` styles the button red (deletes).
export async function confirmAction({ title, text, confirmText = 'Yes', danger = false }) {
  const result = await Swal.fire({
    icon: danger ? 'warning' : 'question',
    title,
    text,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: 'Cancel',
    confirmButtonColor: danger ? '#dc2626' : BRAND,
    focusCancel: danger,
  })
  return result.isConfirmed
}
